<template>
  <b-modal id="login-modal">
    <img src="@/assets/image/login/login-dialog.png" alt="">
    <div class="login-body">
      <div class="login-in">
        <!--        Sign in-->
        <div class="login-first" style="text-align: center">{{ $t('message.login') }} </div>
        <div v-if="isError" class="alert alert-danger" role="alert">{{ errormsg }}</div>
        <!--        User name-->
        <div class="login-two">
          <div>Username</div>
          <input v-model="loginForm.UserName" :placeholder="$t('message.username')" type="text" class="form-control">
        </div>
        <!--        Password-->
        <div class="login-three">
          <div>
            <div>Password</div>
            <div class="hand" @click="handleForgetPwd">Forgot Password ?</div>
          </div>
          <input v-model="loginForm.Password" :placeholder="$t('message.password')" type="password" class="form-control">
        </div>
        <!--        Remember-->
        <div class="login-four">
          <input v-model="remember" type="checkbox">
          <span>{{ $t('message.remeberme') }}</span>
        </div>
        <div class="login-five">
          <div class="hand" @click.prevent="handleLogin">{{ $t('message.login') }}</div>
          <div @click="handleBtcEyes" class="link hand">Cancel and return to website</div>
        </div>
        <!--       Footer-->
        <div class="login-six">
          <div>
            <span>Not a member ?</span>
            <span @click="handleRegister" class="link hand">Register now</span>
          </div>
          <div style="margin-left: 10px">
            <span>Terms Privacy Security ?</span>
            <span @click="handleContactUs" class="link hand">Get In Touch</span>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { getLocalStore, setLocalStore } from '@/utils/common'
import { mapGetters } from 'vuex'

export default {
  inject: ['reload'],
  props: {

  },
  data () {
    return {
      errormsg: '',
      loginForm: {
        UserName: '',
        Password: ''
      },
      logined: false,
      isError: false,
      remember: false,
      captcha: null,
      timer: null
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'token',
      'userow'
    ])
  },
  updated () {
    // 回车登录
    document.onkeyup = (e) => {
      if (e.keyCode === 13 && (!this.logined && (!getLocalStore().username && !getLocalStore().password))) {
        this.handleLogin()
      }
    }
  },
  methods: {
    handleLogin () {
      this.$store.dispatch('Login', this.loginForm).then(() => {
        this.$store.dispatch('GetUserProfile', this.loginForm.UserName).then(() => {
          this.logined = true
          this.isError = false
          // 登录成功保存Token
          if (this.remember) {
            setLocalStore({ token: this.token })
          }
          this.getUserProfile()
          this.$bvModal.hide('login-modal')
        })
        this.$store.dispatch('UpdateUserActivityByToken', this.token)
      }).catch((err) => {
        this.isError = true
        if (err.ErrorCode === 6009) {
          this.errormsg = this.$t('message.userpwdnotmatch')
        }
      })
    },
    getUserProfile () {
      this.$store.dispatch('GetUserProfile', getLocalStore().UserID).then(() => {
        this.reload()
      })
    },
    // 忘记密码
    handleForgetPwd () {
      this.$bvModal.hide('login-modal')
      this.$bvModal.show('forgot-password-modal')
    },
    handleBtcEyes () {
      this.$bvModal.hide('login-modal')
      this.$router.push('/BTCInfo')
    },
    handleRegister () {
      this.$bvModal.hide('login-modal')
      this.$router.push('/Register')
    },
    handleContactUs () {
      this.$bvModal.hide('login-modal')
      this.$router.push('/ContactUs')
    }
  }
}
</script>

<style>
#login-modal .modal-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #535353;
  max-width: 1013px;
  height: 90vh;
}

#login-modal .modal-content{
  border-radius: 20px;
}

#login-modal .modal-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

#login-modal .modal-footer {
  display: none;
}

#login-modal .modal-header {
  display: none;
}
</style>

<style scoped>
/*占位符修改*/
input::-webkit-input-placeholder { /* WebKit browsers */
  font-size: 10px;
  color: #CCCCCC;
}

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  font-size: 10px;
  color: #CCCCCC;
}

input::-moz-placeholder { /* Mozilla Firefox 19+ */
  font-size: 10px;
  color: #CCCCCC;
}

input:-ms-input-placeholder { /* Internet Explorer 10+ */
  font-size: 10px;
  color: #CCCCCC;
}
.link{
  height: 20px;
  font-size: 10px;
  color: #4285F4;
}

.link:hover{
  border-bottom: 1px solid #000000;
}

</style>
